import React from "react";
import PropTypes from "prop-types";
import { cond, equals, T, always } from "ramda";
import { IconName } from '@elearning-platform/ui';

import { OutlinedContainer, DefaultContainer, LoaderContainer, StyledLoaderIcon } from "./button.styled";
import { ButtonVariant } from "./button.constants";

export const Button = ({
  className = '',
  children,
  variant = ButtonVariant.Default,
  type = "button",
  isLoading = false,
  ...buttonProps
}) => {
  const getContainer = cond([
    [equals(ButtonVariant.Outlined), always(OutlinedContainer)],
    [T, always(DefaultContainer)],
  ]);

  const Container = getContainer(variant);

  const onClickHandler = () => {
    if (isLoading) {
      return;
    }

    if (buttonProps.onClick) {
      buttonProps.onClick();
    }
  };

  return (
    <Container
      {...buttonProps}
      onClick={onClickHandler}
      disabled={buttonProps.disabled && !isLoading}
      type={type}
      $variant={variant}
      className={className}
    >
      {children}
      {isLoading && (
        <LoaderContainer>
          <StyledLoaderIcon name={IconName.Loader} size={16} />
        </LoaderContainer>
      )}
    </Container>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  outlined: PropTypes.bool,
  onClick: PropTypes.func,
};
